import { render, staticRenderFns } from "./OurHistory.vue?vue&type=template&id=5bb63951&scoped=true"
import script from "./OurHistory.vue?vue&type=script&lang=js"
export * from "./OurHistory.vue?vue&type=script&lang=js"
import style0 from "./OurHistory.vue?vue&type=style&index=0&id=5bb63951&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb63951",
  null
  
)

export default component.exports